import { Component, Input } from '@angular/core';
import { Esito } from '../../../models/esito';

@Component({
    selector: '[esito_entity_view]',
  templateUrl: 'esito-entity-view.component.html',
})

export class EsitoEntityViewComponent {
  @Input()
  element: Esito;
}
